import { assertInInjectionContext, inject, signal } from '@angular/core';

import { SessionStore } from 'app/core/services/session.store';
import { ExclusiveRequestCoordinator } from 'app/shared/services/exclusive-request-coordinator';

import { NotificationGateway } from '../gateway/notification-gateway';
import { NotificationResource } from '../resource/notification-resource';

export function useMarkAllNotificationsAsRead() {
    assertInInjectionContext(useMarkAllNotificationsAsRead);

    const gateway = inject(NotificationGateway);
    const notificationResource = inject(NotificationResource);
    const requestCoordinator = inject(ExclusiveRequestCoordinator);
    const user = inject(SessionStore).user;
    const loading = signal(false);

    const execute = async (): Promise<void> => {
        const requestUser = user();
        if (!requestUser || loading()) return;

        await requestCoordinator.run('notifications.markAllAsRead', [requestUser.id], async () => {
            loading.set(true);
            try {
                await gateway.markAllAsRead();
                notificationResource.setAllRead(requestUser.id);
            } catch {
                return;
            } finally {
                loading.set(false);
            }
        });
    };

    return {
        loading: loading.asReadonly(),
        execute,
    };
}
